export default class InputTextSelector {
    constructor() {
        this.element = document.querySelectorAll('input[data-text-selector]');
        this.selectInputTextOnFocus();
    }

    selectInputTextOnFocus() {
        if (this.element.length > 0) {
            this.element.forEach((value) => {
                value.addEventListener('focus', (e) => {
                    this.selectInputText(e.currentTarget);
                });
            });
        }
    }

    selectInputText(inputElement) {
        inputElement.setSelectionRange(0, inputElement.value.length);
    }
}
